import PhotosMapViewer from './PhotosMapViewer';

export default PhotosMapViewer;
